import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextMedium } from 'UiKit/typography';
import TableComponent from 'UiKit/table-component';
import getTableList from 'View/host-stock-promo/component/list-stock-detail/const';
import mappedProductStorage from 'View/host-stock-promo/helper/mappedProductStorage';

import styles from './styles.module.css';

const ListStockDetail = ({ data }) => {
  const { t } = useTranslation('host-stock-promo');
  const columns = getTableList(t);
  const dataSource = mappedProductStorage(data);

  return (
    <Box className={styles['list-stock-detail__container']} data-testid="list-stock-detail">
      <TextMedium className={styles['list-stock-detail__title']}>{t('stock_detail.all_warehouses')}</TextMedium>
      <Box className={styles['list-stock-detail__box--table']}>
        <TableComponent
          columns={columns}
          dataSource={dataSource}
          isDataExist={true}
          containerClassName={styles['list-stock-detail__table--container']}
          rowHeight="35px"
          headRowHeight="38px"
        />
      </Box>
    </Box>
  );
};

export default ListStockDetail;
